import _ from 'lodash'

export default function filterRemovedItems(collection, removedStatusPath, showRemoved) {
  if (showRemoved) {
    return collection
  }

  return collection.filter(item => !_.at(item, removedStatusPath)[0])
}
